jQuery(document).ready(function(){
    // alert();
    
    // DOM ready, take it away
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();    
        if (scroll >= 100) {
            $(".header").addClass("darkHeader");
        }else{
            $(".header").removeClass("darkHeader");
        }
    });

    $(".header__menu-item").click(function(){
        if($(this).find("span").text() == "Sale"){
            // alert();
            var val = $(this).find("span").text();
            var url = $(this).attr("href");
            var handle = val.trim();
            handle = handle.replace(/&/g, '');
            handle = handle.replace(/\s+/g, '-').toLowerCase();
            localStorage.setItem("collectionHandle", handle);
            localStorage.setItem("collection", val);
            localStorage.setItem("collectionUrl", url);

        }
    });
    $(".menu-drawer__menu-item").click(function(){
        if($(this).text().trim() == "Sale"){
            // alert($(this).text() );
            var val = $(this).text();
            var url = $(this).attr("href");
            var handle = val.trim();
            handle = handle.replace(/&/g, '');
            handle = handle.replace(/\s+/g, '-').toLowerCase();
            localStorage.setItem("collectionHandle", handle);
            localStorage.setItem("collection", val);
            localStorage.setItem("collectionUrl", url);

        }
    });

    $(".header .header__submenu ul li a").each(function () {
        if($(this).hasClass("list-menu__item--active")){
            // alert();
            var val = $(this).text();
            var handle = val.trim();
            handle = handle.replace(/&/g, '');
            handle = handle.replace(/\s+/g, '-').toLowerCase();
            var url = $(this).attr("href");
            console.log(handle);
            localStorage.setItem("collection", val);
            localStorage.setItem("collectionUrl", url);
            localStorage.setItem("collectionHandle", handle);
        }
    });
    $(".productsBy .prodBox a").click(function(){
        // localStorage.removeItem("collection");
        // localStorage.removeItem("collectionUrl");
        // localStorage.removeItem("collectionHandle");
        localStorage.setItem("collection", "");
        localStorage.setItem("collectionUrl", "");
        localStorage.setItem("collectionHandle", "");

    })
    $(".productsBy .prodBox .byBrand a").click(function(){
        // localStorage.removeItem("collection");
        // localStorage.removeItem("collectionUrl");
        // localStorage.removeItem("collectionHandle");
        var url = $(this).attr("href");
        var val = $(this).attr("data-name");
        var handle = val.trim();
        handle = handle.replace(/&/g, '');
        handle = handle.replace(/\s+/g, '-').toLowerCase();
        localStorage.setItem("collection", val);
        localStorage.setItem("collectionUrl", url);
        localStorage.setItem("collectionHandle", handle);

    })
    $(".productsBy .prodBox .bySolution a").click(function(){
        // localStorage.removeItem("collection");
        // localStorage.removeItem("collectionUrl");
        // localStorage.removeItem("collectionHandle");
        var url = $(this).attr("href");
        var val = $(this).attr("data-name");
        var handle = val.trim();
        handle = handle.replace(/&/g, '');
        handle = handle.replace(/\s+/g, '-').toLowerCase();
        localStorage.setItem("collection", val);
        localStorage.setItem("collectionUrl", url);
        localStorage.setItem("collectionHandle", handle);

    })
    // if(localStorage.getItem("collection")) {
    //     alert(localStorage.getItem("collection"));
    //     $(".breadcrumb-container .collBread").text(localStorage.getItem("collection"));
    // }

    //product page image hover
    var x, y, height;

    $(".main-product-img").mousemove(function (event) {
    if ($(window).width() > 767) {
        var offset = $(this).offset();
        x = event.pageX - offset.left;
        y = event.pageY - offset.top;
        // var xPer = (x / $(this).width() * 100);
        // var yPer = (y / $(this).height() * 100);
        height = -y * 0.5 + $(this).height() * 0.5;
        $(this).css(
        "object-position",
        -x * 0.5 + $(this).width() * 0.5 + "px " + height + "px"
        );
    }
    });

    $(".main-product-img").mouseleave(function (event) {
    $(this).css("object-position", "unset");
    });
})